<ui-detail-section>
    <ui-detail-image
        [imagePath]="mapItem().imagePath"
    />

    @if (mapItem().goals) {
        <ui-detail-section [title]="'Ziele des Angebots:'">
            <ui-detail-description
                [htmlDescription]="mapItem().goals"
            />
        </ui-detail-section>
    }

    @if (mapItem().intendedChanges; as changes) {
        @if (changes.length) {
            <ui-detail-section [title]="'Was soll sich bei den Teilnehmenden durch das Angebot verändern?'">
                <ui-detail-address
                    [text]="changes"
                />
            </ui-detail-section>
        }
    }
</ui-detail-section>
